"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
class Storage {
    constructor(...args) {
        this._subscribers = [];
        this.StorageProvider = new (class {
        })();
        if (args.length === 2) {
            this._fields = args[0].reduce((acc, key) => {
                acc[key] = Object.assign({}, args[1]);
                return acc;
            }, {});
        }
        else {
            this._fields = Object.assign({}, args[0]);
        }
    }
    _emit(changes) {
        if (!this._subscribers.length) {
            return;
        }
        const newState = this.get();
        const allChanges = {
            added: changes.added ? [...changes.added] : [],
            updated: changes.updated ? [...changes.updated] : [],
            removed: changes.removed ? [...changes.removed] : [],
        };
        this._subscribers.forEach((sub) => {
            sub(newState, allChanges);
        });
    }
    _getIdentifier(name) {
        var _a;
        const field = this._fields[name];
        return String((_a = field.key) !== null && _a !== void 0 ? _a : name);
    }
    /**
     * Set default values for fields (that don't exist) in storage.
     */
    persistDefaultValues(overwrite = false) {
        Object.keys(this._fields).forEach((name) => {
            const field = this._fields[name];
            if (!this.has(name) || overwrite) {
                this.set(name, field.defaultValue);
            }
        });
    }
    /**
     * Check if field exists in storage (regardless of value)
     */
    has(name) {
        return this.StorageProvider.has(name);
    }
    get(...args) {
        if (args.length === 1) {
            const [name] = args;
            const field = this._fields[name];
            const value = this.StorageProvider.get(name);
            return value !== null && value !== void 0 ? value : (field.nullable && value === null ? null : field.defaultValue);
        }
        return Object.keys(this._fields).reduce((acc, name) => {
            const field = this._fields[name];
            const value = this.StorageProvider.get(name);
            acc[name] = value !== null && value !== void 0 ? value : ((field === null || field === void 0 ? void 0 : field.nullable) && value === null ? null : field === null || field === void 0 ? void 0 : field.defaultValue);
            return acc;
        }, {});
    }
    set(...args) {
        const changes = {
            added: [],
            updated: [],
            removed: [],
        };
        if (args.length === 1) {
            const [arg] = args;
            const newState = typeof arg === 'function' ? arg(this.get()) : arg;
            for (const name in newState) {
                // Skip unknown fields
                if (!(name in this._fields)) {
                    continue;
                }
                const newValue = newState[name];
                if (this.has(name)) {
                    changes.updated.push(name);
                }
                else {
                    changes.added.push(name);
                }
                this.StorageProvider.set(name, newValue);
            }
        }
        if (args.length === 2) {
            const [name, newValue] = args;
            if (this.has(name)) {
                changes.updated.push(name);
            }
            else {
                changes.added.push(name);
            }
            this.StorageProvider.set(name, newValue);
        }
        this._emit(changes);
    }
    /**
     * Remove one or more fields from storage
     */
    remove(...args) {
        const changes = { added: [], updated: [], removed: [] };
        args.forEach((name) => {
            changes.removed.push(name);
            this.StorageProvider.remove(name);
        });
        this._emit(changes);
    }
    /**
     * Remove all fields from storage
     */
    removeAll() {
        this.remove(...Object.keys(this._fields));
    }
    /**
     * Subscribe to changes (add, update, remove)
     */
    subscribe(subscriber) {
        this._subscribers.push(subscriber);
        return () => {
            this._subscribers = this._subscribers.filter((sub) => sub !== subscriber);
        };
    }
}
exports.Storage = Storage;
